import { NumberParam, useQueryParam } from 'use-query-params';
import { NumberInput } from '../../../../components/shared/input/Input';
import { QueryParamNames } from '../../enums/QueryParamNames';

export function ObjectCountFilter() {
    const [minObjectCount, setMinObjectCount] = useQueryParam(QueryParamNames.MIN_OBJECT_COUNT, NumberParam);
    const [maxObjectCount, setMaxObjectCount] = useQueryParam(QueryParamNames.MAX_OBJECT_COUNT, NumberParam);

    return (
        <div className='col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-2'>
            <p>Objects:</p>
            <div className='flex items-center'>
                <NumberInput min='1' value={minObjectCount ?? null} onChange={setMinObjectCount} />
                <p className='m-0 mx-2'>to</p>
                <NumberInput min='1' value={maxObjectCount ?? null} onChange={setMaxObjectCount} />
            </div>
        </div>
    );
}
